import Hero from "../../../components/landing/Hero";
import Footer from "../../../components/common/Footer";
import Header from "../../../components/common/Header";
import BackToTop from "../../../components/common/BackToTop";
import NewsLetter from "../../../components/common/NewsLetter";
import CoreValues from "../../../components/landing/CoreValues";
import ScholarshipsSection from "../../../components/landing/ScholarshipsSection";
import ContactForm from "../../../components/common/ContactForm";
import BlogAndNews from "../../../components/landing/BlogAndNews";
import Announcements from "../../../components/landing/Announcements";
import LatestProjects from "../../../components/landing/LatestProjects";
import UpcomingEvents from "../../../components/landing/UpcomingEvents";
import Attractions from "../../../components/landing/Attractions";
import { useAbout } from "../../../services/aboutService";
import { useSelector } from "react-redux";
import type { RootState } from "../../../store";

const Landing = () => {
  const { currentLanguage } = useSelector((state: RootState) => state.language);
  const { data: aboutData } = useAbout(currentLanguage);

  return (
    <div className="min-h-screen w-full bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors">
      <Header />
      <main>
        <Hero
          title={aboutData?.hero_title}
          subtitle={aboutData?.hero_title}
          description={aboutData?.hero_description}
          image={aboutData?.hero_image}
        />
        <CoreValues />
        <ScholarshipsSection />
        <LatestProjects />
        <UpcomingEvents />
        <Announcements />
        <BlogAndNews />
        <Attractions />
        <NewsLetter />
      </main>
      <ContactForm
        mapEmbedUrl={aboutData?.contact_map_url}
        address={aboutData?.contact_address}
        email={aboutData?.contact_email}
        phone={aboutData?.contact_phone}
      />
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Landing;
